import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { NFeSaidaEspelhoResponse } from '@shared/services/responses/repo-dfe/nfe-saida-espelho.response';

/** Controller NFeSaida da API RepoDFe. */
@Injectable({ providedIn: 'root' })
export class NFeSaidaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFe + 'NFeSaida';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getEspelho(idNFeSaida: number): Observable<NFeSaidaEspelhoResponse> {
    return this.httpClient
      .get<NFeSaidaEspelhoResponse>(`${this.apiUrl}/idNFeSaida/${idNFeSaida}/espelho`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
